/**
 * Utility helpers for working with user preferences generically.
 */

import {
  GLOBAL_PREFERENCE_KEYS,
  PreferenceScope,
  type UserPreferences,
} from '../types';

/**
 * Given a scope and a preference object, returns a shallow copy that only
 * contains keys relevant for that scope.  This prevents global-only keys from
 * being stored in non-global records and vice-versa.
 */
export function filterPreferencesForScope(
  scope: PreferenceScope,
  prefs: Partial<UserPreferences>
): Partial<UserPreferences> {
  const isGlobal = scope === PreferenceScope.GLOBAL;

  return Object.fromEntries(
    Object.entries(prefs).filter(([key]) => {
      const isGlobalKey = GLOBAL_PREFERENCE_KEYS.includes(
        key as keyof UserPreferences
      );
      return isGlobal ? isGlobalKey : !isGlobalKey;
    })
  ) as Partial<UserPreferences>;
}
